import { useEffect,useState } from "react"
import { Card, Button, Spinner, Row, Col, Modal, CloseButton } from 'react-bootstrap';
import DataGrid from '../../controls/DataGrid.js/DataGrid'
import { useSelector } from 'react-redux';
import Icon from "../../controls/Icons/Icon";
import { useNavigate } from 'react-router-dom';
import { dateDisplayFormater } from "../../../Utils";
import useFetchWithCancellation from "../../../customhooks/useFetchWithCancellation";
import ClientSearchForm from '../Client/ClientSearchForm';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorHandler from "../../controls/ErrorHandler";
const Client = () => {
    const { fetchData } = useFetchWithCancellation();
    const state = useSelector(state => state);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [showSearchForm, setshowSearchForm] = useState(false);
    const [ClientSelected, setClientSelected] = useState(false);
    const [querystring, setquerystring] = useState("");
    const [dataGridUrl, setdataGridUrl] = useState(state.projectdetail.API + "/client/ClientFormGrid");
    const columns = [
        {
            field: "FirstName",
            title: "First Name",
            sortName: "FirstName",
            sortable: true,
        },
        {
            field: "LastName",
            title: "Last Name",
            sortable: true,
        },
        //{
        //    field: "DOB",
        //    title: "DOB",
        //    sortable: true,
        //    formatter: dateDisplayFormater
        //},
        {
            field: "UCINumber",
            title: "UCI Number",
            sortable: true,
            visible: true,
        },
        {
            field: "MotherName",
            title: "Mother's Name",
            sortable: true,
        },
        {
            field: "spendingPlanId",
            title: "SpendingPlan",
            sortable: false,
            visible: false,
        },
        {
            field: "FatherName",
            title: "Father's Name",
            sortable: true,
            visible: true,
        },
        //{
        //    field: "MobileNumber",
        //    title: "Contact No.",
        //    sortable: true,
        //},
        {
            field: "CreatedBy",
            title: "Created By",
            sortable: false,
        },
        {
            field: "CreatedDate",
            title: "Created Date",
            sortable: false,
            formatter: dateDisplayFormater
        },

        {
            dataField: "remove",
            title: "",
            text: "Delete",
            formatter: (cellContent, row) => {
                return (<div>
                    {state.access.edit ? <Button text="PCP" variant="link" tooltip="PCP"
                        className="btn-xs me-2 p-0" variant="link"
                        onClick={() => handleEdit(row, 1)}> <Icon name="BsPeopleFill" title="PCP" className='fs-5' /></Button> : ""}

                    {state.access.edit ? <Button variant="link" style={{ color: row.spendingPlanId > 0 ? '#ffcc00' : 'grey' }} text="Expense" tooltip="Spending Plan"
                        className="btn-xs p-0"
                        onClick={() => handleEdit(row, 2)}>
                        <Icon title="Spending Plan" name="BsPiggyBankFill" className='fs-5' />
                    </Button> : ""}
                    {state.access.delete && state.access.user?.fkRoleId == 1 ? <Button variant="link"
                        className="btn-xs p-0" style={{ color: 'red' }}
                        onClick={() => handleDelete(row)}
                    >
                        <Icon name="BsTrash" className='fs-5' />
                    </Button> : ""}
                </div>
                );
            },
        }
    ];
    const handleEdit = (res, to) => {
        if (to == 1)
            navigate("/admin/pcpform/" + res.Id + "/personal");
        else
            navigate("/admin/pcpform/" + res.Id + "/spendingplangenerator");
    };

    const handleDelete = ((res) => {
        window.confirm("Do you want to delete the Client and Client related data?", function () {
            setLoading(true);
            fetchData(state.projectdetail.API + "/Client/delete?Id=" + res.Id, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
               
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    window.alert("Deleted successfuly");
                    setRefreshGrid(!refreshGrid);
                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("Client.js ==> delete", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
                setLoading(false);
            });
        })

    });

    const handleAdd = () => {
        navigate("/admin/pcpform/0/personal");
    };
    useEffect(() => {
        if (ClientSelected) {
            setClientSelected(false);
            setquerystring(new URLSearchParams({
                FirstName: searchCriteria.FirstName,
                LastName: searchCriteria.LastName,
                UCINumber: searchCriteria.UCINumber,
                MotherName: searchCriteria.MotherName,
                UserId: 0,
                FatherName: searchCriteria.FatherName,
                CreatedBy: searchCriteria.CreatedBy
            }).toString());
            let updatedQueryStr = "FirstName=" + searchCriteria.FirstName + "&&" +
                "LastName=" + searchCriteria.LastName + "&&" +
                "UCINumber=" + searchCriteria.UCINumber + "&&" +
                "MotherName=" + searchCriteria.MotherName + "&&" +
                "FatherName=" + searchCriteria.FatherName + "&&" +
                "CreatedBy=" + searchCriteria.CreatedBy;

            setdataGridUrl(state.projectdetail.API + "/client/SearchClientFormGrid?" + updatedQueryStr)
            setRefreshGrid(!refreshGrid);
        }
    }, [ClientSelected]);
    const [searchCriteria, setsearchCriteria] = useState({
        FirstName: "",
        LastName: "",
        UCINumber: "",
        MotherName: "",
        FattherName: "",
        CreatedBy: ""
    })
    const handleAfter = (inputValue) => {
        setshowSearchForm(false);
        setClientSelected(true);
        searchCriteria.FirstName = inputValue.FirstName;
        searchCriteria.LastName = inputValue.LastName;
        searchCriteria.UCINumber = inputValue.UCINumber;
        searchCriteria.MotherName = inputValue.MotherName;
        searchCriteria.FatherName = inputValue.FatherName;
        searchCriteria.CreatedBy = inputValue.CreatedBy;
    }

    const handleClose = () => {
        setshowSearchForm(false);
    };

    const handlerefresh = () => {
        // setdataGridUrl(state.projectdetail.API + "/client/ClientFormGrid");
        setdataGridUrl(state.projectdetail.API + "/client/ClientFormGrid");
        setRefreshGrid(!refreshGrid);
    }
    const showClientSearchForm = () => {
        setshowSearchForm(true);
    }
    const options = {
        dataType: "server",
        showExport: true,
        showRefresh: true,
        sortName: "CreatedDate",
        sortOrder: "desc",
        exportDocumetName: "Clients",
        toolbar: (state.access.add ? <div><Button onClick={handleAdd}>Add New PCP</Button> <Button onClick={handleAdd}>Add New Spending Plan</Button></div> : <div></div>)
    };
    return (
        <ErrorBoundary FallbackComponent={ErrorHandler}>
            <Row>
                <Col>
                    <h4 className='form-heading'>
                        Client &nbsp;&nbsp;&nbsp;&nbsp; <Icon style={{ cursor: "pointer" }} name="BsSearch" title="Client Search" className='fs-5' onClick={showClientSearchForm} />
                        &nbsp;&nbsp; <Icon style={{ cursor: "pointer" }} name="BsArrowClockwise" title="Refresh" className='fs-5' onClick={handlerefresh} /> 
                    </h4>
                </Col>
            </Row>
            <div>
            <Modal show={showSearchForm} onHide={handleClose}
                size="xl" backdrop="static" keyboard={false}
                dialogClassName="custom-modal-position" >
                <Modal.Header style={{ background: "#0a4081", color: "white" }}>
                    <h4 style={{ fontcolor: 'white' }} > Search Client details </h4>
                    <CloseButton onClick={handleClose} className="btn-close" />
                </Modal.Header>
                <Modal.Body>
                    <ClientSearchForm afterSave={handleAfter} onCancel={handleClose} />
                </Modal.Body>
                </Modal>
            </div>
            <Card>
                <Card.Body>
                    {loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}
                    <DataGrid url={dataGridUrl} classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} />
                </Card.Body>
            </Card>
        </ErrorBoundary>
    );
}

export default (Client);
